module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        _vm.myModel = true;
        _vm.dlg_title = '添加团队'
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-delete"
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("删除")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.users,
      "border": "",
      "highlight-current": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fullName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contact",
      "label": "联系人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "城市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "邮箱"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "启用／停用",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button-group', [(scope.row.isvalid == '1') ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.activeCustomer(scope.row, false)
            }
          }
        }, [_vm._v("停用\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (scope.row.isvalid == '0') ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.activeCustomer(scope.row, true)
            }
          }
        }, [_vm._v("启用\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看\n\t\t\t\t\t\t\t\t\t\t\t")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, prev, pager, next",
      "page-size": _vm.page.size,
      "total": _vm.page.total + 1
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加团队",
      "visible": _vm.myModel,
      "close-on-click-modal": false,
      "width": "750px"
    },
    on: {
      "update:visible": function($event) {
        _vm.myModel = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "label-width": "100px",
      "rules": _vm.rules,
      "model": _vm.addForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "全称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "500px"
    },
    model: {
      value: (_vm.addForm.fullName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "fullName", $$v)
      },
      expression: "addForm.fullName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ukey"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.addForm.user_key),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "user_key", $$v)
      },
      expression: "addForm.user_key"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模块"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.addForm.moduleList),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "moduleList", $$v)
      },
      expression: "addForm.moduleList"
    }
  }, _vm._l((_vm.modules), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v("\n              " + _vm._s(item.label) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省份"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择省份"
    },
    on: {
      "change": function($event) {
        return _vm.getProv($event)
      }
    },
    model: {
      value: (_vm.addForm.province),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "province", $$v)
      },
      expression: "addForm.province"
    }
  }, _vm._l((_vm.provs), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "80px",
      "padding-left": "40px"
    }
  }, [_vm._v("城市")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择城市"
    },
    on: {
      "click": function($event) {
        return _vm.alert()
      },
      "change": function($event) {
        return _vm.getCity($event)
      }
    },
    model: {
      value: (_vm.addForm.city),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "city", $$v)
      },
      expression: "addForm.city"
    }
  }, _vm._l((_vm.citys), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "500px"
    },
    model: {
      value: (_vm.addForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "address", $$v)
      },
      expression: "addForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮编"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.addForm.post_code),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "post_code", $$v)
      },
      expression: "addForm.post_code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "contact"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.addForm.contact),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "contact", $$v)
      },
      expression: "addForm.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人邮箱"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.addForm.email),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "email", $$v)
      },
      expression: "addForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人电话"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.addForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "phone", $$v)
      },
      expression: "addForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "loading": _vm.addLoading,
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.myModel = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b966795"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sys/Group.vue
// module id = 275
// module chunks = 1